#import "../../../../graphql-wrappers/graphql/fragments/edition-fragment.graphql"

mutation SendEditionToFilteredList($input: EditionSendToFilteredListInput!) {
    editionSendToFilteredList(input: $input) {
        edition {
            ...EditionFragment
        }
    }
}
